export enum Endpoints {
    ping = "ping",
    customers = "customers",
    users = "users",
    token = "token",
    producer = "producer",
    producer_mine = "producer/mine",
    product = "product",
    products = "products",
    shop_manager = "shop_manager",
    category = "category",
    categories = "products/categories",
    event = "event",
    events = "events",
    events_mine = "events/mine",
    userProducerId = "user_producer_id",
    featured = "featured",
}

export enum EndpointsNew {
    categories = "product-category",
    categories_all = "product-category/all",
    producer = "producer",
    producer_minify = "producer/minify",
    producer_mine = "producer/mine",
    event = "event",
    profile = "profile",
    event_mine = "event/mine",
    register_producer = "registration-producer",
    product = "product",
    media = "media",
    media_producer = "media/producer",
    verify_email = "verify-email",
    variant = "variant",
    media_mine = "media/mine",
    product_minify = "product/minify",
    product_preview = "product/preview",
    product_mine = "product/mine",
    product_mine_minify = "product/mine/minify",
    product_lot = "product-lot",
    product_lot_mine = "product-lot/mine",
    product_count = "product/count",
    order_status = "order/status",
    shippings = "shippings",
    order = "order",
    orders = "orders",
    featured = "featured",
    product_move_before = "product/move-before",
    product_move_after = "product/move-after",
}
